import {EventWithDetails} from "../../client/EventScheduleClient";
import {Table} from "react-bootstrap";
import React from "react";

interface EventTableProps {
    readings, events, setBrushRange, setRefreshTrigger, refreshTrigger, chartRange
}

export const EventTable = ({ readings, events, setBrushRange, setRefreshTrigger, refreshTrigger, chartRange }: EventTableProps) => {

    const handleRowClick = (event: EventWithDetails) => {
        if (readings) {
            const start = event.start.minus({ minute: 30 }).toUnixInteger()
            const end = event.end.plus({ minute: 30 }).toUnixInteger()
            let eventStartIndex = readings.findIndex(reading => reading.date >= start)
            let eventEndIndex = readings.findIndex(reading => reading.date >= end)

            const updateChart = () => {
                setBrushRange([eventStartIndex, eventEndIndex])

                const chartContainer = document.getElementById('chart-container')
                if (chartContainer) {
                    setRefreshTrigger(refreshTrigger + 1)
                    chartContainer.scrollIntoView({ behavior: 'smooth' })
                }
            }

            if (eventStartIndex == -1) {
                if (eventEndIndex != -1) {
                    eventStartIndex = 0
                    updateChart()
                }
            } else if (eventEndIndex == -1) {
                if (eventStartIndex != -1) {
                    eventEndIndex = readings.length - 1
                    updateChart()
                }
            } else {
                updateChart()
            }
        }
    }

    return <Table striped bordered hover>
        <thead>
        <tr>
            <th>Event ID</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Event Type</th>
        </tr>
        </thead>
        <tbody data-testid="event-table">
        {events.sort((a, b) => a.start.toMillis() - b.start.toMillis()).map((event: EventWithDetails, index) => {
            const range = chartRange()
            const isClickable = range && (range.contains(event.start) || range.contains(event.end))
            return <tr data-testid={`event-row-${index}`} key={index} style={{ cursor: isClickable ? 'pointer' : 'default' }} onClick={() => isClickable && handleRowClick(event)}>
                <td>{event.id}</td>
                <td>{event.start.toFormat('MMM dd HH:mm a')}</td>
                <td>{event.end.toFormat('MMM dd HH:mm a')}</td>
                <td>{event.eventType.displayName}</td>
            </tr>
        })}
        </tbody>
    </Table>
}